module.exports = __webpack_public_path__ + "img/masked_massagista.7be042b7.svg";